<div class="changes-grid">
  <div class="changes-card">
    <div class="card-label" i18n>Previous</div>
    <ng-container *ngIf="!previousInfoDisplayString; else previousDisplayString">
      <app-submission-detail
        *ngFor="let item of previousInfo"
        [label]="item.label"
        [value]="item.value"
        [submissionState]="SubmissionStateEnum.Previous"
        [hasChanged]="item?.hasChanged" />
    </ng-container>
    <ng-template #previousDisplayString>
      <div class="display-string" i18n>{{ previousInfoDisplayString }}</div>
    </ng-template>
  </div>
  <div class="changes-card">
    <div class="card-label" i18n>New</div>
    <ng-container *ngIf="!newInfoDisplayString; else newDisplayString">
      <app-submission-detail
        *ngFor="let item of newInfo"
        [label]="item.label"
        [value]="item.value"
        [submissionState]="SubmissionStateEnum.New"
        [hasChanged]="item?.hasChanged" />
    </ng-container>
    <ng-template #newDisplayString>
      <div class="display-string" i18n>{{ newInfoDisplayString }}</div>
    </ng-template>
  </div>
</div>
